export const SHOW_MARKERS_TOPIC = "amap.showmarkers"; // TODO duplicated with src/Application/Map/index.jsx
export const HIDE_MARKERS_TOPIC = "amap.hidemarkers"; // TODO duplicated with src/Application/Map/index.jsx
export const REMOVE_MARKERS_IN_FOLDER_TOPIC = "amap.removemarkersinfolder";
